<div id="annual-reports" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Annual Reports & Accounts</h2>
    <p class="inner-lead mt-3">
      The Annual Reports of Shah Satnam Ji Girls' College, Sirsa document the year-wise academic progress, achievements,
      and financial accounts of the institution. These reports reflect the college's commitment to transparency and
      accountability.
    </p>

    <hr class="divider">

    <!-- Tab Navigation -->
    <div class="report-tabs-wrapper mt-4">
      <div class="report-tabs">
        <button class="tab-btn" [class.active]="activeTab === 'reports'" (click)="setActiveTab('reports')">
          <i class="fa fa-file-text-o me-2"></i> Annual Report
        </button>
        <button class="tab-btn" [class.active]="activeTab === 'accounts'" (click)="setActiveTab('accounts')">
          <i class="fa fa-calculator me-2"></i> Annual Accounts
        </button>
      </div>
    </div>

    <!-- Content Area -->
    <div class="tab-content-area mt-5">

      <!-- Annual Reports Tab -->
      <div *ngIf="activeTab === 'reports'" class="animate-fade-in">
        <h4 class="section-subtitle">Yearly Academic Reports</h4>
        <div class="row g-4 mt-2">
          <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let report of annualReports">
            <a [href]="report.pdfPath" target="_blank" class="report-year-card">
              <span class="year-text">{{ report.label }}</span>
              <div class="icon">
                <i class="fa" [ngClass]="report.icon || 'fa-chevron-right'"></i>
              </div>
            </a>
          </div>
        </div>
      </div>

      <!-- Annual Accounts Tab -->
      <div *ngIf="activeTab === 'accounts'" class="animate-fade-in">

        <!-- Balance Sheet Section -->
        <div class="mb-section">
          <h4 class="section-subtitle">Annual Balance Sheet</h4>
          <div class="row g-4 mt-2">
            <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let report of balanceSheets">
              <a [href]="report.pdfPath" target="_blank" class="report-year-card">
                <span class="year-text">{{ report.label }}</span>
                <div class="icon">
                  <i class="fa" [ngClass]="report.icon || 'fa-download'"></i>
                </div>
              </a>
            </div>
          </div>
        </div>

        <!-- Income & Expenditure Section -->
        <div>
          <h4 class="section-subtitle">Income & Expenditure Sheet</h4>
          <div class="row g-4 mt-2">
            <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let report of incomeExpenditure">
              <a [href]="report.pdfPath" target="_blank" class="report-year-card">
                <span class="year-text">{{ report.label }}</span>
                <div class="icon">
                  <i class="fa" [ngClass]="report.icon || 'fa-download'"></i>
                </div>
              </a>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>